//
import CostCenterModel from '@/models/Accounting/AccCostCenter'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default [

    /**
     * 
     */
    {
        field       : 'invoice_number',
        type        : 'text',
        value       : '',
        vuetifyProps: {
            label   : 'Folio',
        },
        flex: {
            sm2     : true,
        },
        rules       : ['required'],
    },
    {
        field       : 'business_name',
        type        : 'text',
        vuetifyProps: {
            label   : 'Proveedor',
        },
        flex: {
            sm4     : true,
        },
        value       : '',
        rules       : [ 'required' ],
    },
    {
        field       : 'rut',
        type        : 'rut',
        value       : '',
        vuetifyProps: {
            label   : 'Rut',
        },
        flex: {
            sm3     : true,
        },
        rules       : ['required'],
    },
    {
        field       : 'address',
        type        : 'text',
        vuetifyProps: {
            label   : 'Sucursal',
        },
        flex: {
            sm3     : true,
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'pch_payment_condition_id',
        type        : 'model-auto-complete',
        vuetifyProps: {
            label       : 'Método de pago',
            itemText    : 'type',
            itemValue   : 'id',
            model       : PaymentConditionModel,
            noObject    : true,
            paramSearch : 'type',
            readonly    : true,
        },
        flex: {
            sm3     : true,
        },
        value       : '',
        rules       : [ 'required' ],
    },

    /**
     * 
     */
    {
        field       : 'emission_date',
        type        : 'datePicker',
        value       : '',
        vuetifyProps: {
            label   : 'Fecha emisión',
        },
        flex: {
            sm3     : true,
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'payment_date',
        type        : 'datePicker',
        value       : '',
        vuetifyProps: {
            label   : 'Fecha pago',
        },
        flex: {
            sm3     : true,
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'accounting_date',
        type        : 'datePicker',
        value       : '',
        vuetifyProps: {
            label   : 'Fecha contable',
        },
        flex: {
            sm3     : true,
        },
        rules       : [ 'required' ],
    },
    {
        flex: {
            sm3     : true,
        }
    },
    {
        field   : 'table',
        flex    : {
            xs12    : true,
            'my-4'  : true,
        },
        type    : 'slot',
    },

    /**
     * 
     */
    {
        field       : 'acc_cost_center_id',
        type        : 'model-auto-complete',
        vuetifyProps: {
            label       : 'Centro costo',
            itemText    : 'name',
            itemValue   : 'id',
            model       : CostCenterModel,
            noDataText  : 'No se encontraron centros de costo.',
            noObject    : true,
            paramSearch : 'name',
        },
        flex: {
            sm4     : true,
        },
        value       : '',
        rules       : [ 'required' ],
    },
    {
        flex: {
            sm4     : true,
        }
    },
    {
        field       : 'new_subtotal',
        type        : 'text',
        maxLength   : 15,
        format      : 'currency',
        value       : '',
        vuetifyProps: {
            label   : 'Neto',
            readonly: true,
        },
        flex: {
            sm2     : true,
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'iva',
        type        : 'text',
        maxLength   : 15,
        format      : 'currency',
        value       : '',
        vuetifyProps: {
            label   : 'IVA',
            readonly: true,
        },
        flex: {
            sm2     : true,
        },
        rules       : [ 'required' ],
    },
    {
        field       : 'is_exent',
        type        : 'checkbox',
        value       : false,
        vuetifyProps: {
            label   : 'Factura exenta',
            readonly: true,
        },
        flex: {
            sm2     : true,
        },
    },
    {
        field       : 'payable',
        type        : 'checkbox',
        value       : false,
        vuetifyProps: {
            falseValue  : true,
            label       : 'Bloquear pago',
            readonly    : true,
            trueValue   : false,
        },
        flex: {
            sm2     : true,
        },
    },
    {
        flex: {
            sm6     : true,
        }
    },
    {
        field       : 'total',
        type        : 'text',
        maxLength   : 18,
        format      : 'currency',
        value       : '',
        vuetifyProps: {
            label   : 'Total',
            readonly: true,
        },
        flex: {
            sm2     : true,
        },
        rules       : [ 'required' ],
    },
]
